/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Contact\UserContact\UserContact.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Friday July 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 5th February 2024 11:55:21
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Contact/UserForm/UserForm.module.css";
import { Form, Col } from "react-bootstrap";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { LanguageType } from "Type/language.type";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "Content/Contact/UserForm/PhoneInput.css";

type UserFormProps = {
    onUpdate: Function,
    // languages: LanguageType[],
    role: string,
};

const UserForm = forwardRef((props: UserFormProps, ref) => {
    const [lastName, setLastName] = useState<string>();
    const [firstName, setFirstName] = useState<string>();
    const [email, setEmail] = useState<string>();
    const [phone, setPhone] = useState<string | undefined>(undefined);
    const [cellPhone, setCellPhone] = useState<string | undefined>(undefined);
    // const [myLanguage, setMyLanguage] = useState<LanguageType>({Name: "", Picture: {URI: ""}, FilePath: "", Key: "", id: ""});
    // const [identity, setIdentity] = useState<File>();
    // const address = useRef<ContactAddress>();

    // const setIdentityFile = (e: any) => {
    //     if (e.target && e.target.files && e.target.files.length > 0)
    //         return e.target.files[0];
    //     return undefined;
    // };

    useImperativeHandle(ref, () => {
        props.onUpdate();
        return {
            lastName,
            firstName,
            email,
            phone,
            cellPhone,
            // language: myLanguage?.id !== "" ? myLanguage?.id : undefined,
            // identityFile: identity,
        }
    // }, [lastName, firstName, email, phone, cellPhone, myLanguage, identity]);
    }, [lastName, firstName, email, phone, cellPhone]);

    return (
        <div className={`${Styles.formHolder}`}>
            <h3>{translator.decode("dynamic.user")}</h3>
            <Form.Group className={`${Styles.formfield}`} >
                <TextField required value={lastName ?? ""} sx={{width:"100%"}} label={translator.decode("dynamic.lastname")} size="small" onChange={(e) => {setLastName(e.target.value)}} autoFocus/>
            </Form.Group>

            <Form.Group className={`${Styles.formfield}`} >
                <TextField required value={firstName ?? ""} sx={{width:"100%"}} label={translator.decode("dynamic.firstname")} size="small" onChange={(e) => {setFirstName(e.target.value)}}/>
            </Form.Group>

            <Form.Group className={`${Styles.formfield}`} >
                <TextField label={translator.decode("dynamic.email")} sx={{width:"100%"}} size="small" required value={email ?? ""} onChange={(e) => {setEmail(e.target.value)}}/>
            </Form.Group>
            {/* <Form.Group className={`${Styles.formfield}`} >
                <FormControl className={`${Styles.formfield}`} size="small">
                    <InputLabel required className={`${Styles.fieldLabel}`} id="select-language-label">{translator.decode("dynamic.languages")}</InputLabel>
                    <Col>
                        <Select required className={`${Styles.select} ${Styles.test}`} label={translator.decode("dynamic.languages")} labelId={"select-language-label"} value={myLanguage.id} onChange={(e) => setMyLanguage(props.languages.find((val) => val.id === e.target.value!)!)}>
                            {
                                props.languages.map((val) => <MenuItem key={`lang-${val.Key}`}value={val.id} ><img className={`${Styles.languagePicture}`} src={val.Picture?.URI} /><span>{translator.decode(`language.list.values.${val.Key.toLowerCase()}`)}</span></MenuItem>)
                            }
                        </Select>
                    </Col>
                </FormControl>
            </Form.Group> */}
            <Form.Group className={`${Styles.formfield}`} >
                <Form.Label className={`${Styles.fieldLabel}`}>
                    {translator.decode("dynamic.phone")}
                </Form.Label>
                <Col>
                    <PhoneInput autoComplete="on" value={phone} onChange={setPhone} defaultCountry={process.env.REACT_APP_AUTOBUY_COUNTRY_ENV == "FR" ? "FR" : "ES"} />
                    {/* <Form.Control type="tel" minLength={10} maxLength={15} pattern="(\+[0-9]{2,3}|00[0-9]{1,2}|[0-9]{2})[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}" required value={phone} onChange={(e) => {setPhone(e.target.value)}}/> */}
                </Col>
            </Form.Group>
            <Form.Group className={`${Styles.formfield}`} >
                <Form.Label className={`${Styles.fieldLabel}`}>
                    {translator.decode("dynamic.cellPhone")}
                </Form.Label>
                <Col>
                    <PhoneInput autoComplete="on" value={cellPhone} onChange={setCellPhone} defaultCountry={process.env.REACT_APP_AUTOBUY_COUNTRY_ENV == "FR" ? "FR" : "ES"} />
                    {/* <Form.Control type="tel" required pattern="(\+[0-9]{2,3}|00[0-9]{1,2}|[0-9]{2})[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}" value={cellPhone} onChange={(e) => {setCellPhone(e.target.value)}}/> */}
                </Col>
            </Form.Group>
            {/* {props.role === "CLIENT" ?
                <Form.Group className={`${Styles.formfield}`} >
                    <Form.Label>
                        {translator.decode("dynamic.identityPiece")}
                    </Form.Label>
                    <Col>
                        <Form.Control required type="file" onChange={(e) => {setIdentity(setIdentityFile(e))}} accept=".pdf,.png,.jpg,.jpeg"/>
                    </Col>
                </Form.Group>
            : null} */}
        </div>
    )
});

export default UserForm;
